import {useState, useEffect} from 'react'
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import Navbar from './component/Navbar'
import Home from './component/Home'
import FromTemp from './component/FromTemp';
import Square from './component/shap/Square';
import Rectangle from './component/shap/Rectangle';
import C_channel from './component/shap/C-channel';
import U_channel from './component/shap/U-channel';
import Door_channel from './component/shap/Door_channel';
import Elliptical from './component/shap/Elliptical';
import L_angle from './component/shap/L-angle';
import Round from './component/shap/Round';
import Flat_oval from './component/shap/Flat-oval';
import Triangular_slit from './component/shap/Triangular-slit';
import Triangular from './component/shap/Triangular';
import Top_hat from './component/shap/Top-hat';
import D_shap from './component/shap/D-shap';
import T_shap from './component/shap/T-shap';
import FromScratch from './component/FromScratch/FromScratch';
import Figure_of_eight from './component/shap/Figure-of-eight';
import L_angle_1 from './component/shap/L-angle-1';
import L_angle_2 from './component/shap/L-angle-2';
import L_angle_3 from './component/shap/L-angle-3';
import Round_1 from './component/shap/Round-1';
import L_angle_4 from './component/shap/L-angle-4';
import Round_2 from './component/shap/Round-2';
import L_angle_5 from './component/shap/L-angle-5';
import Round_3 from './component/shap/Round-3';
import Signup from './component/Signup';
import Login from './component/Login';
import RefrshHandler from './RefrshHandler';
import ManagerDashboard from './component/ManagerDeshboard';
import ForgotPassword from './component/ForgotPassword';
import ResetPassword from './component/ResetPassword';
import PageNotFound from './component/PageNotFound';
import Start from './component/Start';
import Beam_window_frame from './component/shap/Beam-window-frame';
import FromDxf from './component/FromDxf';
import Stiffner from './component/shap/Stiffner';
import Good_knight_tube from './component/shap/Good-knight-tube';
import T_shap_2 from './component/shap/T-shap-2';
import T_shap_3 from './component/shap/T-shap-3';
import Round_4 from './component/shap/Round-4';
import Stiffner_front_edge from './component/shap/Stiffner-front-edge';
import Door_edge_profile from './component/shap/Door-edge-profile';
import M from './component/shap/M';
import D_section from './component/shap/D-section';
import H_section from './component/shap/H-section';
import Lip_channel from './component/shap/Lip-channel';
import Cover_tray from './component/shap/Cover-tray';
import Double_center_mullion from './component/shap/Double-center-mullion';
import Beam_window_frame_1 from './component/shap/Beam-window-frame-1';
import Waist_rail_section from './component/shap/Waist-rail-section';
import Z_section from './component/shap/Z-section';
import Sole_bar_section from './component/shap/Sole-bar-section';
import Sill_pressing from './component/shap/Sill-pressing';
import Trapiz_tube from './component/shap/Trapiz-tube';
import Guide_rail from './component/shap/Guide-rail';
import A_post from './component/shap/A-post';
import Lower_frame from './component/shap/Lower-frame';
import Support_tube from './component/shap/Support-tube';
import Lip_cover from './component/shap/Lip-cover';
import Bts from './component/shap/Bts';
import M_diamond_tube from './component/shap/M-diamond-tube';
import C_section from './component/shap/C-section';
import Cabin_section from './component/shap/Cabin-section';
import Bus_body_section from './component/shap/Bus-body-section';
import Cabin_door_frame from './component/shap/Cabin-door-frame';
import Crimped_rail from './component/shap/Crimped-rail';
import C_post from './component/shap/C-post';
import Skirt_rail from './component/shap/Skirt-rail';
import Monitou_lip_tube from './component/shap/Monitou-lip-tube';
import Swiss_profile_section from './component/shap/Swiss-profile-section';
import Hollow_guide_rail from './component/shap/Hollow-guide-rail';
import Backhoe_a_piller from './component/shap/Backhoe-a-piller';
import A_piller from './component/shap/A-piller';
import T_shape_6 from './component/shap/T-shape-6';
import Trip_tube from './component/shap/Trip-tube';
import Hand_rail_section from './component/shap/Hand-rail-section';
import Door_profile from './component/shap/Door-profile';
import Front_cross_member from './component/shap/Front-cross-member';
import Frame_profile from './component/shap/Frame-profile';
import C_rail from './component/shap/C-rail';
import Formwork from './component/shap/Formwork';
import C_pillar from './component/shap/C-pillar';
import A_post_2 from './component/shap/A-post-2';
import Front_st_a_pillar from './component/shap/Front-st-a-pillar';
import D_pillar_rear from './component/shap/D-pillar-rear';
import Enquiry from './component/Enquiry';
import AdminPanel from './component/AdminPanel';
import MyDrawing from './component/MyDrawing';
import Z1_section from './component/shap/Z1_section';
import { fetchMaterials } from './services/Material';
import AccessGuard from './component/AccessGuard';
import AccessExpired from './component/AccessExpired';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const permission = localStorage.getItem('role');
  const [loading, setLoading] = useState(true);
  const [materials, setMaterials] = useState({});

  useEffect(() => {
    const loadMaterials = async () => {
      try {
        const data = await fetchMaterials();
        for(let i=0; i<data.length; i++){
          const material = data[i];
          setMaterials(prevMaterials => ({...prevMaterials, [material.density]: material.material}));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    loadMaterials();
  }, []);

const PrivateRoute = ({ element }) =>{
  if(isAuthenticated) return <AccessGuard>{element}</AccessGuard>;
  else return <Navigate to='/login'/>
}

  return (
    <div>
      <Router>
        <RefrshHandler setIsAuthenticated={setIsAuthenticated} setLoading={setLoading}/>
        <Navbar/>
        {!loading && 
        <Routes>
          <Route exact path="/" element={<Start/>}/>
          <Route exact path="/access-expired" element={<AccessExpired/>}/>
          <Route exact path="/home" element={<PrivateRoute element={<Home/>}/>}/>
          {(permission === "Admin" || permission === "New Admin") && <Route exact path="/admin-panel" element={<PrivateRoute element={<AdminPanel/>}/>}/>}
          {(permission === "Admin" || permission === "New Admin") && <Route exact path="/manager_dashboard" element={<PrivateRoute element={<ManagerDashboard/>}/>}/>}
          <Route exact path="/login" element={<Login/>}/>
          <Route exact path="/signup" element={<Signup/>}/>
          <Route exact path="/forgot-password" element={<ForgotPassword/>}/>
          <Route exact path="/reset-password/:id/:token" element={<ResetPassword/>}/>
          <Route exact path="/from-temp" element={<PrivateRoute element={<FromTemp materials = {materials}/>}/>}/>
          <Route exact path="/from_scratch" element={<PrivateRoute element={<FromScratch materials = {materials}/>}/>}/>
          <Route exact path="/from-dxf" element={<PrivateRoute element={<FromDxf materials = {materials}/>}/>}/>
          <Route exact path="/rectangle" element={<PrivateRoute element={<Rectangle materials = {materials}/>}/>}/>
          <Route exact path="/d_section" element={<PrivateRoute element={<D_section materials = {materials}/>}/>}/>
          <Route exact path="/round" element={<PrivateRoute element={<Round materials = {materials}/>}/>}/>
          <Route exact path="/round-1" element={<PrivateRoute element={<Round_1 materials = {materials}/>}/>}/>
          <Route exact path="/round-2" element={<PrivateRoute element={<Round_2 materials = {materials}/>}/>}/>
          <Route exact path="/round-3" element={<PrivateRoute element={<Round_3 materials = {materials}/>}/>}/>
          <Route exact path="/round-4" element={<PrivateRoute element={<Round_4 materials = {materials}/>}/>}/>
          <Route exact path="/square" element={<PrivateRoute element={<Square materials = {materials}/>}/>}/>
          <Route exact path="/l-angle" element={<PrivateRoute element={<L_angle materials = {materials}/>}/>}/>
          <Route exact path="/c-channel" element={<PrivateRoute element={<C_channel materials = {materials}/>}/>}/>
          <Route exact path="/U-channel" element={<PrivateRoute element={<U_channel materials = {materials}/>}/>}/>
          <Route exact path="/triangular-slit" element={<PrivateRoute element={<Triangular_slit materials = {materials}/>}/>}/>
          <Route exact path="/door_channel" element={<PrivateRoute element={<Door_channel materials = {materials}/>}/>}/>
          <Route exact path="/stiffner_front_edge" element={<PrivateRoute element={<Stiffner_front_edge materials = {materials}/>}/>}/>
          <Route exact path="/door_edge_profile" element={<PrivateRoute element={<Door_edge_profile materials = {materials}/>}/>}/>
          <Route exact path="/elliptical" element={<PrivateRoute element={<Elliptical materials = {materials}/>}/>}/>
          <Route exact path="/flat_oval" element={<PrivateRoute element={<Flat_oval materials = {materials}/>}/>}/>
          <Route exact path="/triangular" element={<PrivateRoute element={<Triangular materials = {materials}/>}/>}/>
          <Route exact path="/top_hat" element={<PrivateRoute element={<Top_hat materials = {materials}/>}/>}/>
          <Route exact path="/m" element={<PrivateRoute element={<M materials = {materials}/>}/>}/>
          <Route exact path="/d_shap" element={<PrivateRoute element={<D_shap materials = {materials}/>}/>}/>
          <Route exact path="/t_shap" element={<PrivateRoute element={<T_shap materials = {materials}/>}/>}/>
          <Route exact path="/t_shap_2" element={<PrivateRoute element={<T_shap_2 materials = {materials}/>}/>}/>
          <Route exact path="/t_shap_3" element={<PrivateRoute element={<T_shap_3 materials = {materials}/>}/>}/>
          <Route exact path="/figure_of_eight" element={<PrivateRoute element={<Figure_of_eight materials = {materials}/>}/>}/>
          <Route exact path='/l-angle-1' element={<PrivateRoute element={<L_angle_1 materials = {materials}/>}/>}/>
          <Route exact path='/l-angle-2' element={<PrivateRoute element={<L_angle_2 materials = {materials}/>}/>}/>
          <Route exact path='/l-angle-3' element={<PrivateRoute element={<L_angle_3 materials = {materials}/>}/>}/>
          <Route exact path='/l-angle-4' element={<PrivateRoute element={<L_angle_4 materials = {materials}/>}/>}/>
          <Route exact path='/l-angle-5' element={<PrivateRoute element={<L_angle_5 materials = {materials}/>}/>}/>
          <Route exact path='/beam-window-frame' element={<PrivateRoute element={<Beam_window_frame materials = {materials}/>}/>}/>
          <Route exact path='/beam-window-frame-1' element={<PrivateRoute element={<Beam_window_frame_1 materials = {materials}/>}/>}/>
          <Route exact path='/stiffner' element={<PrivateRoute element={<Stiffner materials = {materials}/>}/>}/>
          <Route exact path='/good-knight-tube' element={<PrivateRoute element={<Good_knight_tube materials = {materials}/>}/>}/>
          <Route exact path='/H-section' element={<PrivateRoute element={<H_section materials = {materials}/>}/>}/>
          <Route exact path='/Lip-channel' element={<PrivateRoute element={<Lip_channel materials = {materials}/>}/>}/>
          <Route exact path='/cover_tray' element={<PrivateRoute element={<Cover_tray materials = {materials}/>}/>}/>
          <Route exact path='/double_center_mullion' element={<PrivateRoute element={<Double_center_mullion materials = {materials}/>}/>}/>
          <Route exact path='/waist-rail-section' element={<PrivateRoute element={<Waist_rail_section materials = {materials}/>}/>}/>
          <Route exact path='/z-section' element={<PrivateRoute element={<Z_section materials = {materials}/>}/>}/>
          <Route exact path='/sole-bar-section' element={<PrivateRoute element={<Sole_bar_section materials = {materials}/>}/>}/>
          <Route exact path='/sill-pressing' element={<PrivateRoute element={<Sill_pressing materials = {materials}/>}/>}/>
          <Route exact path='/trapiz-tube' element={<PrivateRoute element={<Trapiz_tube materials = {materials}/>}/>}/>
          <Route exact path='/guide-rail' element={<PrivateRoute element={<Guide_rail materials = {materials}/>}/>}/>
          <Route exact path='/a-post' element={<PrivateRoute element={<A_post materials = {materials}/>}/>}/>
          <Route exact path='/support-tube' element={<PrivateRoute element={<Support_tube materials = {materials}/>}/>}/>
          <Route exact path='/lower-frame' element={<PrivateRoute element={<Lower_frame materials = {materials}/>}/>}/>
          <Route exact path='/Lip-cover' element={<PrivateRoute element={<Lip_cover materials = {materials}/>}/>}/>
          <Route exact path='/bts' element={<PrivateRoute element={<Bts materials = {materials}/>}/>}/>
          <Route exact path='/m-diamond-tube' element={<PrivateRoute element={<M_diamond_tube materials = {materials}/>}/>}/>
          <Route exact path='/C-section' element={<PrivateRoute element={<C_section materials = {materials}/>}/>}/>
          <Route exact path='/cabin-section' element={<PrivateRoute element={<Cabin_section materials = {materials}/>}/>}/>
          <Route exact path='/bus-body-section' element={<PrivateRoute element={<Bus_body_section materials = {materials}/>}/>}/>
          <Route exact path='/cabin-door-frame' element={<PrivateRoute element={<Cabin_door_frame materials = {materials}/>}/>}/>
          <Route exact path='/crimped-rail' element={<PrivateRoute element={<Crimped_rail materials = {materials}/>}/>}/>
          <Route exact path='/c-post' element={<PrivateRoute element={<C_post materials = {materials}/>}/>}/>
          <Route exact path='/Skirt-rail' element={<PrivateRoute element={<Skirt_rail materials = {materials}/>}/>}/>
          <Route exact path='/t_shap_4' element={<PrivateRoute element={<Monitou_lip_tube materials = {materials}/>}/>}/>
          <Route exact path='/swiss-profile-section' element={<PrivateRoute element={<Swiss_profile_section materials = {materials}/>}/>}/>
          <Route exact path='/t_shap_5' element={<PrivateRoute element={<Hollow_guide_rail materials = {materials}/>}/>}/>
          <Route exact path='/backhoe-a-piller' element={<PrivateRoute element={<Backhoe_a_piller materials = {materials}/>}/>}/>
          <Route exact path='/a-piller' element={<PrivateRoute element={<A_piller materials = {materials}/>}/>}/>
          <Route exact path='/t_shape_6' element={<PrivateRoute element={<T_shape_6 materials = {materials}/>}/>}/>
          <Route exact path='/trip-tube' element={<PrivateRoute element={<Trip_tube materials = {materials}/>}/>}/>
          <Route exact path='/hand-rail-section' element={<PrivateRoute element={<Hand_rail_section materials = {materials}/>}/>}/>
          <Route exact path='/door-profile' element={<PrivateRoute element={<Door_profile materials = {materials}/>}/>}/>
          <Route exact path='/front-cross-member' element={<PrivateRoute element={<Front_cross_member materials = {materials}/>}/>}/>
          <Route exact path='/frame-profile' element={<PrivateRoute element={<Frame_profile materials = {materials}/>}/>}/>
          <Route exact path='/c-rail' element={<PrivateRoute element={<C_rail materials = {materials}/>}/>}/>
          <Route exact path='/Formwork' element={<PrivateRoute element={<Formwork materials = {materials}/>}/>}/>
          <Route exact path='/c-pillar' element={<PrivateRoute element={<C_pillar materials = {materials}/>}/>}/>
          <Route exact path='/a-post-2' element={<PrivateRoute element={<A_post_2 materials = {materials}/>}/>}/>
          <Route exact path='/front-st-a-pillar' element={<PrivateRoute element={<Front_st_a_pillar materials = {materials}/>}/>}/>
          <Route exact path='/d-pillar-rear' element={<PrivateRoute element={<D_pillar_rear materials = {materials}/>}/>}/>
           <Route exact path='/z1_section' element={<PrivateRoute element={<Z1_section materials = {materials}/>}/>}/>
          {(permission === "Admin" || permission === "Super User" || permission === "New Admin") && <Route exact path='/enquiry' element={<PrivateRoute element={<Enquiry/>}/>}/>}
          <Route exact path='/mydrawing' element={<PrivateRoute element={<MyDrawing/>}/>}/>
          <Route exact path='*' element={<PrivateRoute element={<PageNotFound/>}/>}/>
        </Routes>}
      </Router>
    </div>
  )
}

export default App
